// 医生端APP中使用的，与小飞侠相关的页面

const doctorAppRouter = [
  {
    path: '/doctorappuploadpatientlist',
    name: 'doctor-app-upload-patient-list',
    meta: {
      title: "患者列表"
    },
    component: () =>
      import('@/views/doctorApp/uploadPatientListPage/patientListPage'),
  },
  {
    path: '/doctorappdoctorlist',
    name: 'doctor-app-doctor-list',
    meta: {
      // TODO-T 临时修改
      // title: "医护列表"
      // ----------
      title: "医生列表"
    },
    component: () =>
      import('@/views/doctorApp/doctorListPage/doctorListPage'),
  },
  {
    path: '/doctorappframeworkpatientlist',
    name: 'doctor-app-framework-patient-list',
    meta: {
      title: "患者列表"
    },
    component: () =>
      import('@/views/doctorApp/frameworkPatientListPage/frameworkPatientListPage'),
  },
  {
    path: '/doctorappupload',
    name: 'doctor-app-upload',
    meta: {
      title: "上传病历"
    },
    component: () =>
      import('@/views/doctorApp/uploadPage/uploadPage'),
  },
  {
    path: '/bookingbedcalendar',
    name: 'booking-bed-calendar',
    meta: {
      title: "预约住院"
    },
    component: () =>
      import('@/views/doctorApp/bookingBed/bookingBedCalendarPage/bookingBedCalendarPage'),
  },
  {
    path: '/bookingbedpatientlist',
    name: 'booking-bed-patient-list',
    meta: {
      title: "预约住院"
    },
    component: () =>
      import('@/views/doctorApp/bookingBed/bookingBedPaitentListPage/bookingBedPaitentListPage'),
  },
  {
    path: '/allfunctionpatientlist',
    name: 'all-funtion-patient-list',
    meta: {
      title: "患者列表"
    },
    component: () =>
      import('@/views/doctorApp/allFunctionPatientListPage/allFunctionPatientListPage'),
  },
  {
    path: '/allfunctionpatientmain',
    name: 'all-function-patient-main',
    meta: {
      title: "患者详情",
    },
    component: () =>
      import('@/views/doctorApp/allFunctionPatientMainPage/allFunctionPatientMainPage'),
  },
  {
    path: '/doctorappaeform',
    name: 'doctor-app-ae-form',
    meta: {
      title: "AE填写"
    },
    component: () =>
      import('@/views/doctorApp/aeForm/aeFormPage.vue'),
  },
  {
    path: '/doctorReportinterpret',
    name: 'doctorReportinterpret',
    meta: {
      title: "报告解读"
    },
    component: () =>
      import('@/views/doctorApp/allFunctionPatientMainPage/doctorReportinterpret'),
  },
  {
    path: '/doctorReportinterpretDetail',
    name: 'doctorReportinterpretDetail',
    meta: {
      title: "报告解读"
    },
    component: () =>
      import('@/views/doctorApp/allFunctionPatientMainPage/doctorReportinterpretDetail'),
  },
  {
    path: '/nursehighriskpatientlist',
    name: 'nurse-high-risk-patient-list',
    meta: {
      title: "高风险患者列表"
    },
    component: () =>
      import('@/views/doctorApp/nurseHighRiskPatientListPage/nurseHighRiskPatientListPage'),
  },
  {
    path: '/nurseReportinterpret',
    name: 'nurseReportinterpret',
    meta: {
      title: "报告解读"
    },
    component: () =>
      import('@/views/doctorApp/nurseHighRiskPatientListPage/nurseReportinterpret'),
  },
  {
    path: '/doctorpersonalinfo',
    name: 'doctor-personal-info',
    meta: {
      title: "个人资料"
    },
    component: () =>
      import('@/views/doctorApp/doctorPersonalInfoPage/doctorPersonalInfoPage'),
  },
  {
    path:'/myclinical',
    name:'myclinical',
    meta: {
      title: "我的临床试验"
    },
    component: () =>
      import('@/views/doctorApp/myClinicalTrials/myClinicalTrials'),
  },
  {
    path:'/injection',
    name:'injectionList',
    meta: {
      title: "注射列表"
    },
    component: () =>
        import('@/views/doctorApp/injectionlist/injectionlistPage.vue'),
  },
  {
    path:'/patientHomepage',
    name:'patientHomepage',
    meta: {
      title: "患者主页"
    },
    component: () =>
        import('@/views/doctorApp/injectionlist/patientHomepage.vue'),
  },
    {
    path:'/aerecord',
    name:'AEConfirm',
    meta: {
      title: "AE审核"
    },
    component: () =>
        import('@/views/doctorApp/aeConfirm/aeConfirm.vue'),
  },
  {
    path: '/cancerSelection',
    name:'cancerSelection',
    meta: {
      title: '癌肿选择'
    },
    component:() =>
      import('@/views/doctorApp/cancerSelection/cancerSelection.vue')

  },
  {
    path: '/referralRecords',
    name:'referralRecords',
    meta: {
      title: '转诊记录',
      keepAlive: true
    },
    component:() =>
        import('@/views/doctorApp/referralRecords/referralRecords.vue')

  },
  {
    path: '/optiCare',
    name:'opti-care',
    meta: {
      title: '患者列表',
    },
    component:() =>
        import('@/views/doctorApp/optiCareList/optiCareListPage.vue')

  },
  {
    path:'/callList',
    name:'call-list',
    meta: {
      title: 'AI外呼记录'
    },
    component: () =>
        import('@/views/doctorApp/callList/callList.vue')
  },
  {
    path:'/callDetails',
    name:'call-Details',
    meta: {
      title: '外呼详情'
    },
    component: () =>
        import('@/views/doctorApp/callList/callDetails.vue')
  },
  {
    path:'/proactivelyInquire',
    name:'proactively-Inquire',
    meta: {
      title: '主动问询'
    },
    component: () =>
        import('@/views/doctorApp/inquireList/inquireList.vue')
  },
  {
    path: '/checkMeasures',
    name: 'check-measures',
    meta: {
      title: "查看处理措施",
    },
    component: () =>
        import('@/views/doctorApp/allFunctionPatientMainPage/checkMeasures.vue'),
  },


]

export default doctorAppRouter
